import React, { ReactElement } from 'react'

function Step1Tooltip(): ReactElement {
  return (
    <div className="card cardSm textPrimaryDark w23 fontSizeXs">
      <p>
        La vérification régulière de votre identité permet de garantir votre
        protection. N.B. : le titre de séjour recouvre la notion de carte de
        séjour et de carte de résident.
      </p>
    </div>
  )
}

export default Step1Tooltip
